import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumbComp from "../../component/breadCrumb/breadCrump";
import AssetSummary from "./assetSummary";
import ProfileCde from "./profile_cde";
import ConfigureDqRule from "./configureDqRule";
import { TabMenu } from "primereact/tabmenu";
import DqRuleHistory from "./dqRuleHistory";
import { getColumnsNames, getCheckNames, getConfigureDQAssetRule, getdataAsset, getdataAssetProfile, getDimensionNames, getSampleData, ruleRecommendation, getConfigureDQColumnRule, getDQRuleHistory, setDataAssetActiveTab, getDimension, getADLSAccountList } from "../../redux/dataAsset/dataAsset.action";
import { useParams } from "react-router-dom";
import { Toast } from "primereact/toast";
import { SET_API_DATA, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "../../redux/dataAsset/dataAsset.type";
import DataContract from "./dataContract";
import Alerts from "./alerts";
function DataAssetPage() {
   const { apiData, dataAssetActiveTab } = useSelector((state) => state.dataAsset)

   const { steppersData } = useSelector((state) => state.crumbs)

   const [activeIndex, setActiveIndex] = useState(0);
   const { dataAssetId } = useParams();
   const dispatch = useDispatch()




   const changeDetail = (e, type, value) => {
      switch (type) {
         case "multiSelect": {
            dispatch({
               type: SET_FORM_VALUE,
               payload: {
                  formField: e.target.name,
                  value: value
               }
            })
            break
         }
         case "number": {
            dispatch({
               type: SET_FORM_VALUE,
               payload: {
                  formField: e.target.name,
                  value: value
               }
            })
            break
         }
         case "text": {
            dispatch({
               type: SET_FORM_VALUE,
               payload: {
                  formField: e.target.name,
                  value: e.target.value
               }
            })
            break
         }
         case "dropdown": {
            dispatch({
               type: SET_FORM_VALUE,
               payload: {
                  formField: e.target.name,
                  value: value
               }
            })
            dispatch({
               type: SET_FORM_VALUEOBJ,
               payload: {
                  formField: e.target.name,
                  valueAsObj: e.target.value
               }
            })
            break
         }
         case "file": {
            dispatch({
               type: SET_FORM_VALUE,
               payload: {
                  formField: e.target.name,
                  value: e.target.files[0]
               }
            })
            break
         }
         default: console.log("No type present : " + type)
      }
   }

   const items = [
      { id: 0, label: <span style={{ paddingLeft: "10px" }}>ASSET SUMMARY</span>, element: <AssetSummary dataAssetId={dataAssetId}  changeDetail={changeDetail}/> },
      { id: 1, label: 'PROFILE/CDE', element: <ProfileCde changeDetail={changeDetail} dataAssetId={dataAssetId} />, disabled: apiData.profileCde.data.length === 0 },
      { id: 2, label: 'DQ RULES', element: <ConfigureDqRule changeDetail={changeDetail} /> },
      { id: 3, label: 'RULES HISTORY', element: <DqRuleHistory dataAssetId={dataAssetId} changeDetail={changeDetail} /> },
      { id: 4, label: 'ALERTS', element: <Alerts changeDetail={changeDetail} /> },
      // { id: 5, label: 'VIEW DQ RULES', element: <FileExplorer/> },

      // { id: 6, label: 'DATA CONTRACT', element: <DataContract changeDetail={changeDetail} /> }

   ];
   const toast = useRef(null);
  
   const show = () => {
      toast.current.show({ severity: apiData.runProfiler.status === "success" ? "success" : apiData.runProfiler.status === "fail" ? "error" : 'info', summary: apiData.runProfiler.status, detail: apiData.runProfiler.data });
      dispatch({
         type: SET_API_DATA,
         payload: {
            apiField: "runProfiler",
            data: [],
            status: "idle",

         },
      })
   };


  
   const getElement = () => {
      return items.filter((val) => val.id === dataAssetActiveTab)[0].element
   }
   useEffect(() => {
      dispatch(getdataAsset(dataAssetId))
      dispatch(getdataAssetProfile(dataAssetId))
      dispatch(getSampleData(dataAssetId))
      dispatch(getConfigureDQAssetRule(dataAssetId))
      dispatch(getCheckNames(dataAssetId))
      dispatch(getDimensionNames(dataAssetId))
      dispatch(getDimension())
      dispatch(getColumnsNames(dataAssetId))
      dispatch(getConfigureDQColumnRule(dataAssetId))
      dispatch(getDQRuleHistory(dataAssetId))
      dispatch(ruleRecommendation(dataAssetId))
      dispatch(getADLSAccountList())
   }, [])

   return <Fragment>
      <BreadCrumbComp items={steppersData.dataAssetSteps}/>
      <div className="card">
         <TabMenu model={items} activeIndex={dataAssetActiveTab} onTabChange={(e) => {
            dispatch({
               type: SET_FORM_OPTION,
               payload: {
                  formField: "selectedProfile",
                  data: []
               }
            })
            dispatch(setDataAssetActiveTab(e.index))
         }} />
      </div>
      {getElement()}
   </Fragment>
}

export default DataAssetPage